module.exports = __webpack_public_path__ + "media/images/app/occasions/professional-e55df4b5eb4e837372363a907a1a8a26.webp";